<app-modal-base [title]="dialogTitle" (onSubmitEvent)="onSubmit()" [loading]="formSubmitting"
  [isDisabled]="doneForm.invalid">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div class="formContainer d-flex justify-content-center">
      <form [formGroup]="doneForm">
        <div class="form-group row">
          <mat-form-field class="col-md-6">
            <mat-label>Date</mat-label>
            <input *ngIf="isBrowserSupportsDateInput(); else datePicker" matInput placeholder="" type="date" required
              formControlName="date" />
            <ng-template #datePicker>
              <input class="date-picker" matInput [matDatepicker]="picker" required formControlName="date" />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </ng-template>
            <mat-error>
              <span *ngIf="f('date').hasError('required')">Veuillez saisir une date</span>
              <span *ngIf="f('date').hasError('dateFuture')">Date future non autorisée</span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-group row">
          <mat-form-field class="col-md-12">
            <mat-label>Commentaires</mat-label>
            <textarea matInput placeholder="" formControlName="comments"></textarea>
            <mat-error>
              <span *ngIf="f('comments').hasError('maxlength')">Les commentaires ne doivent pas dépasser 160
                caractères</span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="form-group row">
          <mat-form-field class="col-md-6">
            <mat-label>Coût (€)</mat-label>
            <input matInput placeholder="" type="text" formControlName="cost" nullValue decimalValue />
            <mat-error>
              <span *ngIf="f('cost').hasError('pattern') || f('cost').hasError('min')">Le coût doit être un nombre
                positif"</span>
            </mat-error>
          </mat-form-field>
          <mat-form-field class="col-md-6">
            <mat-label>Entreprise</mat-label>
            <input matInput placeholder="" type="text" formControlName="company" />
            <mat-error>
              <span *ngIf="f('company').hasError('maxlength')">Le nom ne doit dépasser 50 caractères</span>
            </mat-error>
          </mat-form-field>
        </div>
        <p>Document</p>
        <div class="form-group row">
          <app-doc-add-widget class="col-12" [prop]="data.prop" category="MAINTENANCE" title="Nouveau"
            (docSelected)="onDocSelected($event)" (docDeleted)="onDocDeleted($event)"
            [withSelect]="false"></app-doc-add-widget>
        </div>
      </form>
    </div>
  </div>
</ng-template>